module.exports = __webpack_public_path__ + "img/c02_buildingstartechhandcart_Normal_ua.493d206e.webp";